define('views/components/distributor_manager/distributor_manager',['require','backbone','text!templates/components/distributor_manager/distributor_manager.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/distributor_manager/distributor_manager.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'distributor-manager-item'
    });
});
